import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import AnimationPreviewStageFrame from './AnimationPreviewStageFrame';
import PlayerControls from './PlayerControls';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #f7f8fa;
`;

function AnimationPreviewStage() {
  const store_preview = store.preview;

  return (
    <Container className="test">
      <AnimationPreviewStageFrame />
      {store_preview && (
        <PlayerControls
          player={store_preview.player}
          loaded={store_preview.loaded}
        />
      )}
    </Container>
  );
}

export default observer(AnimationPreviewStage);
